import React from 'react'
import PropTypes from 'prop-types'
import dynamic from 'next/dynamic'

import styles from './style.module.scss'
import { addAdsInsideParagraph, addEditorAds } from '@shared-submodule/utils'
import InnerHTML from '@shared/components/InnerHTML'
const ListicleArticle = dynamic(() => import('@shared/components/articleDetail/listicleArticle'))
const CommonContent = dynamic(() => import('@shared/components/commonContent'))
const LiveArticle = dynamic(() => import('@shared/components/liveArticle'))

function ArticleContent({ article, liveArticle }) {
  function getArticleContent() {
    if (article?.bIsListicleArticle) {
      return <ListicleArticle article={article} outerStyle={styles} />
    } else if (article?.iEventId) {
      return (
        <>
          {liveArticle?.oLiveArticleContent?.sFirstContent ? <CommonContent>
            <InnerHTML
              className={`${styles.content} text-break`}
              html={liveArticle?.oLiveArticleContent?.sFirstContent}
            />
          </CommonContent> : null}
          <div className='my-3'>
            <LiveArticle liveArticleList={liveArticle?.aLiveArticleList} liveArticleEvent={liveArticle?.oLiveArticleEvent} liveEventId={article?.iEventId} />
          </div>
          {liveArticle?.oLiveArticleContent?.sLastContent ? <CommonContent>
            <InnerHTML
              className={`${styles.content} text-break`}
              html={liveArticle?.oLiveArticleContent?.sLastContent}
            />
          </CommonContent> : null}
        </>
      )
    } else {
      return <CommonContent>
        <InnerHTML
          className={`${styles.content} text-break`}
          html={addEditorAds(addAdsInsideParagraph(article?.sContent, [0, 1, 2, 5]))}
        />
      </CommonContent>
    }
  }

  const Tag = (p) => (
    <div key={p?.index}>
      {/* <CustomLink href={'/' + p?.item?.oSeo?.sSlug} prefetch={false}> */}
        {/* <a target='_blank' className={p?.item?.eStatus === 'i' ? 'disabled' : ''}> */}
          <span className="badge bg-primary">{p?.item?.sName}</span>
        {/* </a> */}
      {/* </CustomLink> */}
    </div>
  )
  return (
    <>
      {getArticleContent()}
      <div className={`${styles.tagList} d-flex flex-lg-wrap pb-2 pb-lg-0`}>
        {article?.aSeries?.map((item, index) => <Tag key={item?._id} item={item} index={index} />)}
        {article?.aTeam?.map((item, index) => <Tag key={item?._id} item={item} index={index} />)}
        {article?.aPlayer?.map((item, index) => <Tag key={item?._id} item={item} index={index} />)}
        {article?.aTags?.map((item, index) => <Tag key={item?._id} item={item} index={index} />)}
      </div>
    </>
  )
}
ArticleContent.propTypes = {
  article: PropTypes.object,
  liveArticle: PropTypes.object
}

export default ArticleContent
